
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { HelpCircle, Edit2, Sparkles } from "lucide-react";
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";

interface PromptHeaderProps {
  isReadOnly: boolean;
  onEdit: () => void;
  onGeneratePrompt?: () => void;
  hasGenerateFeature?: boolean;
}

export const PromptHeader = ({ 
  isReadOnly, 
  onEdit, 
  onGeneratePrompt,
  hasGenerateFeature = false
}: PromptHeaderProps) => {
  return (
    <div className="flex justify-between items-start">
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <Label htmlFor="system-prompt" className="text-base">System Prompt</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="ghost" size="icon" className="h-5 w-5">
                  <HelpCircle className="h-4 w-4 text-muted-foreground" />
                </Button>
              </TooltipTrigger>
              <TooltipContent className="max-w-80">
                <p>The system prompt defines how the AI agent behaves, what knowledge it has access to, and how it should respond to user inputs.</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <p className="text-sm text-muted-foreground">
          This prompt defines the agent's behavior, capabilities, and communication style
        </p>
      </div>
      
      <div className="flex gap-2">
        {hasGenerateFeature && onGeneratePrompt && (
          <Button
            variant="outline"
            size="sm"
            onClick={onGeneratePrompt}
            className="gap-2"
          >
            <Sparkles className="h-4 w-4 text-amber-500" />
            AI Suggest
          </Button>
        )}
        
        {!isReadOnly && (
          <Button
            variant="outline"
            size="sm"
            onClick={onEdit}
            className="gap-2"
          >
            <Edit2 className="h-4 w-4" />
            Guided Edit
          </Button>
        )}
      </div>
    </div>
  );
};
